import React, { FC, useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { useDispatch, useSelector } from 'react-redux'
import { ISfWallet } from '@sparling/financial-common'
import { Typography } from '@mui/material'
import { TableComponent } from '../../../../../../../components/Dashboard/Table'
import { columns } from './WalletsList'
import { WalletsModal } from './WalletsModal'
import { userSfWalletsSelector } from '../../../../../../../store/selectors'
import { readUserSfWalletsRequest } from '../../../../../../../store/actions'
// import { openAddNewWalletPopup, readUserSfWalletsRequest } from '../../../../../../../store/actions'
// import { GreenButton } from '../../../../../../../components/Dashboard/Buttons/GreenButton'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    marginTop: theme.spacing(3),
    padding: theme.spacing(3),
    height: '100%',
  },
  titleWrap: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    minWidth: 400,
  },
  table: {
    paddingTop: theme.spacing(2),
  },
  buttonWrap: {
    justifyContent: 'flex-end',
  },
}))

export const Wallets: FC = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { data, status } = useSelector(userSfWalletsSelector)
  const [isOpenAccountModal, setOpenAccountModal] = useState<boolean>(false)
  const [selectedAccountId, setSelectedAccountId] = useState<number | null>(null)

  const loadAccountsData = useCallback(
    (page = 1) => {
      dispatch(
        readUserSfWalletsRequest({
          page,
        }),
      )
    },
    [dispatch],
  )

  useEffect(() => {
    loadAccountsData()
  }, [loadAccountsData])

  const getSelectedElementIdHandle = useCallback((id) => {
    setSelectedAccountId(id)
  }, [])

  const openWalletModalHandle = useCallback(() => {
    setOpenAccountModal(true)
    setSelectedAccountId(null)
  }, [])

  // const openGenerateWalletModalHandle = useCallback(() => {
  //   dispatch(openAddNewWalletPopup({ open: true }))
  // }, [dispatch])

  const closeWalletModalHandle = useCallback(() => setOpenAccountModal(false), [])

  return (
    <Grid container display={'flex'}>
      <Grid container className={classes.container}>
        <Grid container className={classes.titleWrap}>
          <Grid item xs={8} display="flex">
            <Typography variant={'h6'}>Wallets</Typography>
          </Grid>
          {/* <Grid item xs={4} display="flex" justifyContent={'flex-end'}> */}
          {/*   <GreenButton width={140} ml={8} text={'Generate'} onClick={openGenerateWalletModalHandle} /> */}
          {/* </Grid> */}
        </Grid>
        <Grid container className={classes.table}>
          <TableComponent
            page={data.meta.currentPage}
            getUserId={getSelectedElementIdHandle}
            columns={columns}
            data={data.items}
            params={data.meta}
            onShow={openWalletModalHandle}
            loading={status === 'LOADING'}
            loadData={loadAccountsData}
          ></TableComponent>
        </Grid>
      </Grid>
      {isOpenAccountModal && (
        <WalletsModal
          isOpen={true}
          modalClose={closeWalletModalHandle}
          fields={data.items.find((item) => item.id === selectedAccountId) as ISfWallet}
        />
      )}
    </Grid>
  )
}
